import { getValidationMessages } from '@/common/constants/validation-messages';
import * as yup from 'yup';

const messages = getValidationMessages();

const GRAIN_CLASSES = {
  CLASS_1: '1',
  CLASS_2: '2',
  CLASS_3: '3',
  CLASS_4: '4',
  CLASS_5: '5',
} as const;

const RESTRICTED_CLASSES = [
  GRAIN_CLASSES.CLASS_3,
  GRAIN_CLASSES.CLASS_4,
  GRAIN_CLASSES.CLASS_5,
];

function isRestrictedClass(grain_class: string | undefined): boolean {
  return RESTRICTED_CLASSES.includes(grain_class as any);
}

export const analysisSchema = yup.object().shape({
  humidity: yup
    .string()
    .required(messages.required)
    .test(
      'class-humidity',
      "Namlik 17% dan yuqori bo'lmasligi kerak",
      function (value) {
        const { grain_class } = this.parent;
        if (!value || !isRestrictedClass(grain_class)) return true;
        return Number(value) <= 17;
      },
    ),

  pollution: yup
    .string()
    .required(messages.required)
    .test(
      'class-pollution',
      "Ifloslik 5% dan yuqori bo'lmasligi kerak",
      function (value) {
        const { grain_class } = this.parent;
        if (!value || !isRestrictedClass(grain_class)) return true;
        return Number(value) <= 5;
      },
    ),

  natura: yup
    .string()
    .required(messages.required)
    .test('class-natura', function (value) {
      const { grain_class } = this.parent;
      if (!value || !isRestrictedClass(grain_class)) return true;

      const num = Number(value);

      // if (grain_class === GRAIN_CLASSES.CLASS_5) {
      //   if (num > 710) {
      //     return this.createError({
      //       message: "Natura 710 grammdan yuqori bo'lmasligi kerak",
      //     });
      //   }
      // }

      if (num < 710) {
        return this.createError({
          message: "Natura 710 grammdan kam bo'lmasligi kerak",
        });
      }

      return true;
    }),

  grain_mixture: yup
    .string()
    .required(messages.required)
    .test(
      'class-grain-mixture',
      "15% dan yuqori bo'lmasligi kerak",
      function (value) {
        const { grain_class } = this.parent;
        if (!value || !isRestrictedClass(grain_class)) return true;
        return Number(value) <= 15;
      },
    ),

  kleykovina: yup
    .string()
    .required(messages.required)
    .test('class-kleykovina', function (value) {
      const { grain_class } = this.parent;
      if (!value) return true;

      const num = Number(value);

      if (grain_class === GRAIN_CLASSES.CLASS_3) {
        if (num < 23) {
          return this.createError({
            message: "Kleykovina 23 dan kam bo'lmasligi kerak",
          });
        }
      }

      if (grain_class === GRAIN_CLASSES.CLASS_4) {
        if (num < 18 || num > 22) {
          return this.createError({
            message: "Kleykovina 18 dan 22 gacha bo'lishi kerak",
          });
        }
      }

      // if (grain_class === GRAIN_CLASSES.CLASS_5) {
      //   if (num > 17) {
      //     return this.createError({
      //       message: "Kleykovina 17 dan yuqori bo'lmasligi kerak",
      //     });
      //   }
      // }

      return true;
    }),

  steklovidnost: yup
    .string()
    .required(messages.required)
    .test(
      'class-steklovidnost',
      "Steklovidnost 40 dan 60 gacha bo'lishi kerak",
      function (value) {
        const { grain_class } = this.parent;
        if (!value) return true;

        if (
          grain_class === GRAIN_CLASSES.CLASS_3 ||
          grain_class === GRAIN_CLASSES.CLASS_4
        ) {
          const num = Number(value);
          return num >= 40 && num <= 60;
        }

        return true;
      },
    ),

  grain_class: yup.string().required(messages.required),

  farmer_contract_id: yup.string().required(messages.required),

  prime_grain: yup.string().when('$isSeed', {
    is: true,
    then: (schema) =>
      schema
        .required(messages.required)
        .test('max', '96% dan oshmasligi kerak', (value) => {
          if (!value) return true;
          return Number(value) <= 96;
        }),
    otherwise: (schema) => schema.optional(),
  }),
  selected_date: yup.string().optional(),
});
